import { SvgIcon } from '@mui/material';
import { ReactComponent as TermsIconSVG } from "./terms.svg";

export default function IconTerms(props) {
  return <SvgIcon {...props} component={TermsIconSVG} viewBox="0 0 16 16" />;
}